<template>
    <div class="Site PageBox">
      <van-nav-bar
        fixed
        :border="false"
        :title="navBarTitle"
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
      <div class="ScrollBox">
        <div class="search">
          <div>
            <input type="text" readonly v-model="startDate" @click="showDate=true,currentDate=new Date(startDate),pickType=1">
            -
            <input type="text" readonly v-model="endDate" @click="showDate=true,currentDate=new Date(endDate),pickType=2">
          </div>
          <van-button type="info" size="mini" @click="getTeamReport">{{$t('teamReport.default[0]')}}</van-button>
        </div>
        <div style="margin: 0 10px; box-shadow: 0 1px 2px rgb(0 0 0 / 20%);border-radius: 5px;">
        <van-grid class="MyEarnings" :column-num="2" :border="false" >
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[7]')}}({{$t('teamReport.default[9]')}})
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamNumber||'0'}}</span>
                </template>
              </van-grid-item>
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[22]')}}
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamVip ||'0'}}</span>
                </template>
              </van-grid-item> 	  
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[4]')}}({{InitData.currency}})
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamWithdrawal}}</span>
                </template>
              </van-grid-item>
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[21]')}}
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamWithdrawalNum}}</span>
                </template>
              </van-grid-item>
            </van-grid>
            <van-grid class="MyEarnings" :column-num="2" :border="false" gutter="5">
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[23]')}}({{InitData.currency}})
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamSpread||'0'}}</span>
                </template>
              </van-grid-item>
              <van-grid-item>
                <template #icon>
                  {{$t('teamReport.default[24]')}}({{InitData.currency}})
                </template>
                <template #text>
                   <span style="color: var(--theme-color);">{{reportData.teamRebate ||'0'}}</span>
                </template>
              </van-grid-item>
            </van-grid>
            <van-grid class="MyEarnings" :column-num="1" :border="false" gutter="5">
              <van-grid-item>
                <template #icon>
                {{$t('teamReport.default[25]')}}({{InitData.currency}})
                </template>
                <template #text>
                 <span style="color: var(--theme-color);">{{reportData.levelTotalWithdraw||'0'}}</span>
                </template>
              </van-grid-item>
            </van-grid>  
        </div>
        <div style="margin: 10px;;border-radius: 5px;background:#fff;">
        <van-row style="padding: 10px;text-align: center;" type="flex" justify="space-between">
            <van-col span="24">
              <div v-if="reportData.groupData" style="margin:5px;padding:10px;background-color: rgb(244, 245, 247);color: #000; justify-content: flex-start; text-align: justify; border-radius: 5px; box-shadow: 0 1px 2px rgb(0 0 0 / 20%); border: 1px solid rgba(0, 0, 0, 0.1);">
                <div style="display: flex;flex-direction: row;color: #999;">
                  <div style="width: calc(100% - 120px);color: #1D1F2C;">
                    {{$t('teamReport.team[0]')}}
                  </div>
                  <div style="float: right;width: 120px;text-align: right;color: var(--theme-color);" @click="openUser(0)">
                    {{$t('teamReport.default[29]')}} >
                  </div>
                </div>
                <van-grid class="MyEarnings" :column-num="3" :border="false" gutter="5" >
                  <div style="height:5px;wihth:100%;font-size: 10px;"></div>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[0].userCount||'0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[30]')}}</span>
                    </template>
                  </van-grid-item>
                    <van-grid-item>
                      <template #icon>
                        <span style="color: var(--theme-color);">
                          {{reportData.groupData[0].cnt||'0'}}
                        </span>
                      </template>
                      <template #text>
                        <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[19]')}}</span>
                      </template>
                    </van-grid-item>
                    <van-grid-item>
                      <template #icon>
                        <span style="color: var(--theme-color);">
                          {{reportData.groupData[0].money || '0'}}
                        </span>
                      </template>
                      <template #text>
                        <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[18]')}}({{InitData.currency}})</span>
                      </template>
                    </van-grid-item>
                  </van-grid>
              </div>
            </van-col>
            <van-col span="24">
              <div v-if="reportData.groupData" style="margin:5px;padding:10px;background-color: rgb(244, 245, 247);color: #000; justify-content: flex-start; text-align: justify; border-radius: 5px; box-shadow: 0 1px 2px rgb(0 0 0 / 20%); border: 1px solid rgba(0, 0, 0, 0.1);">
                <div style="display: flex;flex-direction: row;color: #999;">
                  <div style="width: calc(100% - 120px);color: #1D1F2C;">
                    {{$t('teamReport.team[1]')}}
                  </div>
                  <div style="float: right;width: 120px;text-align: right;color: var(--theme-color);" @click="openUser(1)">
                    {{$t('teamReport.default[29]')}} >
                  </div>
                </div>
                <van-grid class="MyEarnings" :column-num="3" :border="false" gutter="5" >
                  <div style="height:5px;wihth:100%;font-size: 10px;"></div>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[1].userCount||'0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[30]')}}</span>
                    </template>
                  </van-grid-item>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[1].cnt||'0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[19]')}}</span>
                    </template>
                  </van-grid-item>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[1].money || '0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[18]')}}({{InitData.currency}})</span>
                    </template>
                  </van-grid-item>
                </van-grid>
              </div>
            </van-col>
            <van-col span="24">
              <div v-if="reportData.groupData" style="margin:5px;padding:10px;background-color: rgb(244, 245, 247);color: #000; justify-content: flex-start; text-align: justify; border-radius: 5px; box-shadow: 0 1px 2px rgb(0 0 0 / 20%); border: 1px solid rgba(0, 0, 0, 0.1);">
                <div style="display: flex;flex-direction: row;color: #999;">
                  <div style="width: calc(100% - 120px);color: #1D1F2C;">
                    {{$t('teamReport.team[2]')}}
                  </div>
                  <div style="float: right;width: 120px;text-align: right;color: var(--theme-color);" @click="openUser(2)">
                    {{$t('teamReport.default[29]')}} >
                  </div>
                </div>
                <van-grid class="MyEarnings" :column-num="3" :border="false" gutter="5" >
                  <div style="height:5px;wihth:100%;font-size: 10px;"></div>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[2].userCount||'0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[30]')}}</span>
                    </template>
                  </van-grid-item>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[2].cnt||'0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[19]')}}</span>
                    </template>
                  </van-grid-item>
                  <van-grid-item>
                    <template #icon>
                      <span style="color: var(--theme-color);">
                        {{reportData.groupData[2].money || '0'}}
                      </span>
                    </template>
                    <template #text>
                      <span style="font-size: 10px;height: 28px;">{{$t('teamReport.default[18]')}}({{InitData.currency}})</span>
                    </template>
                  </van-grid-item>
                </van-grid>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      
      <Footer />
      <van-popup v-model="showDate" position="bottom" close-on-popstate>
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :title="$t('teamReport.default[16]')"
          :min-date="minDate"
          @confirm="confirmDate"
          @cancel="showDate=false"
        />
      </van-popup>
      <!-- 图标位置 -->
      <van-popup
        v-model="usersShow"
        closeable
        close-icon-position="top-left"
        position="bottom"
        :style="{ height: '100%' }"
      >
      <div style="margin-top: 50px;">
        <van-cell v-if="userList.length>0" :border="false" v-for="(item,index) in userList" :key="index">
          <!-- <div slot="icon">
            <img :src="`./static/images/login/logo.png`" width="40px" height="40px">
          </div> -->
          <template #title>
            <div>
              <span>{{item.username}}</span>
            </div>
          </template>
          <template #label>
            <div>
              <span>{{dayFromat(item.reg_time)}}</span>
            </div>
          </template>
          <!-- <template #extra>
            <div>
              {{$t('teamReport.default[23]')}}(<span style="color: var(--theme-color);">{{item.nextNum}}</span>)
            </div>
          </template> -->
        </van-cell>
        <div v-if="userList.length<1" style="display: flex;justify-content: center; align-items: center;margin-top: 50%;">
          <svg-icon icon-file-name="nomessage" style="font-size: 280px;"></svg-icon>
        </div>
      </div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import dayjs from "dayjs";
  export default {
    name: 'TeamReport',
    components: {
    },
    props: [],
    data() {
      return {
        tabsIndex: 0,
        currentDate: '',
        startDate: this.$Util.DateFormat('YY-MM-DD',new Date().setDate(new Date().getDate())),
        endDate: this.$Util.DateFormat('YY-MM-DD',new Date()),
        showDate: false,
        minDate: new Date(2020,0,1),
        pickType: 1,
        reportData: {
          team1: '',
          team2: '',
          team3: '',
          teamProfit:0
        },
        lowerName: [],
        currPid: '',
        teamActive: 0,
        navBarTitle:'',
        usersShow: false,
        userList:[],
      }
    },
    computed: {
  
    },
    watch: {
  
    },
    created() {
      switch(this.tabsIndex){
        case 1:
          this.navBarTitle = this.$t('teamReport.tabs[1]')
          break;
        default:
          this.navBarTitle = this.$t('teamReport.tabs[0]')
      }
      this.getTeamReport()
      this.$Model.GetUserInfo();
    },
    mounted() { 

    },
    activated() {
  
    },
    destroyed() {
      
    },
    methods: {
      dayFromat(val) {
        console.log(new Date(val));
        return dayjs(val).format("DD/MM/YYYY");
      },
      openUser(index){
        this.usersShow = true;
        this.userList = this.reportData.groupData[index].usersData;
        console.log(this.userList);
      },
      confirmDate(date) {
        if(this.pickType==1){
          this.startDate = this.$Util.DateFormat('YY-MM-DD',date)
        }
        if(this.pickType==2){
          this.endDate = this.$Util.DateFormat('YY-MM-DD',date)
        }
        this.showDate = false
      },
      changeTabs(index){
        switch(index){
          case 1:
            this.$parent.navBarTitle = this.$t('teamReport.tabs[1]')
            break;
          default:
            this.currPid = ''
            this.lowerName = []
            this.$parent.navBarTitle = this.$t('teamReport.tabs[0]')
            this.getTeamReport()
        }
      },
      getSubUser(pid,name) {
        this.lowerName.push({name: name,pve_id: pid})
        this.getMyTeam(pid)
      },
      getTeamReport() {
        let post = {startdate: this.startDate,enddate: this.endDate}
        if(this.currPid){
          post.pve_id = this.currPid
        }
        this.$Model.TeamReport(post,data=>{
          if(data.code==1){
            data.teamData = Object.values(data.teamData)
            this.reportData = data;
          }
        })
      },
      getMyTeam(pid) {
        let post = {pve_id: pid,startdate: this.startDate,enddate: this.endDate}
        this.currPid = pid
        this.$Model.TeamReport(post,data=>{
          if(data.code==1){
            this.reportData.teamData = Object.values(data.teamData)
          }else{
            this.reportData.teamData = []
          }
        })
      },
      lowerReport(pid,index){
        if(pid){
          this.currPid = pid
          if(index!=this.lowerName.length-1){
            this.getMyTeam(pid)
            this.lowerName = this.lowerName.slice(0,index+1);
          }
        }else{
          this.currPid = ''
          this.lowerName = []
          this.getTeamReport()
        }
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .PageBox{
      overflow: hidden;
      padding-bottom: 3.25rem;
    }
  table{
    text-align: center;
    margin-bottom: 20px;
  }
  table tr th{
    padding: 6px 5px;
    background-color: #fff;
    color: #333;
  }
  
  table tr td{
    border: 1px #151d31 solid;
    padding: 10px 5px;
    color: #4087f1;
  }
  table tr td:first-child,table tr td:last-child{
    border-left: 0;
  }
  table tr td em{
    color: #4087f1;
  }
  .search{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }
  .search input{
    border: 1px #ddd solid;
    border-radius: 5px;
    width: 110px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    color: #333;
  }
  .MyTeam .bar{
    padding: 0 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .MyTeam .bar a{
    color: #888;
  }
  .MyTeam .bar i{
    color: #1989fa;
  }
    .val {
      text-align: center;
      color: #000;
      h2 {
        margin: 10px 0 0 0;
      }
    }
    .ul-one {
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  
  .MyEarnings {
    /deep/.van-grid-item__content {
      color: #333;
      font-size: 1.125rem;
      text-align: center;
      border-radius: 5px;
      border: none;
    }
  }
  /deep/ .van-nav-bar__title{color:#fff}
  /deep/ .van-nav-bar .van-icon{color:#fff !important}
  </style>